import {isChrome, isChromium, isEdge, isFirefox, isIE, isOpera, isSafari} from "react-device-detect";
import EnumBrowser from "../enums/EnumBrowser";

export default function GetBrowser() {

    if (isChrome) {
        return EnumBrowser.GoogleChrome;
    } else if (isChromium) {
        return EnumBrowser.Chromium;
    } else if (isFirefox) {
        return EnumBrowser.Firefox;
    } else if (isSafari) {
        return EnumBrowser.Safari;
    } else if (isOpera) {
        return EnumBrowser.Opera;
    } else if (isEdge) {
        return EnumBrowser.Edge;
    } else if (isIE) {
        return EnumBrowser.IE;
    } else {
        return EnumBrowser.Other;
    }


}
